'use client';

import React, { CSSProperties, ReactNode } from 'react';
import type { UrlObject } from 'url';
import { StyledNextLink } from './Link.styles';
export { StyledAnchor } from './Link.styles';

type UrlType = string | UrlObject;

interface Props {
  children?: ReactNode;
  href: UrlType;
  prefetch?: boolean;
  scroll?: boolean;
  variant?: LinkVariant;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
  customStyle?: CSSProperties;
  itemscope?: boolean;
  itemtype?: string;
  itemprop?: string;
  shallow?: boolean;
  replace?: boolean;
  target?: string;
  rel?: string;
  role?: React.AriaRole;
  'data-testid'?: string;
  ariaSelected?: boolean;
  ariaCurrent?: boolean | 'page' | 'step' | 'location' | 'date' | 'time' | undefined;
  tabIndex?: number;
}

const Link = ({
  variant,
  scroll = true,
  prefetch,
  href = '/',
  children,
  className,
  onClick,
  customStyle,
  itemscope,
  itemtype,
  itemprop,
  shallow,
  replace,
  target,
  rel,
  role,
  ariaSelected,
  ariaCurrent,
  tabIndex,
  ...props
}: Props) => {
  return (
    <StyledNextLink
      href={href}
      prefetch={prefetch}
      scroll={scroll}
      shallow={shallow}
      replace={replace}
      $variant={variant}
      itemScope={itemscope}
      itemProp={itemprop}
      itemType={itemtype}
      style={customStyle}
      onClick={(e) => (onClick ? onClick(e) : null)}
      className={className}
      target={target}
      rel={rel}
      data-testid={props['data-testid']}
      role={role}
      aria-selected={ariaSelected}
      aria-current={ariaCurrent}
      tabIndex={tabIndex}
    >
      {children}
    </StyledNextLink>
  );
};

export default Link;
